import { z } from 'zod';
// Flashcard type. In practice v1 flashcards use the same vocabulary as MCQ/TF
// `category` — 'fact' | 'causal' | 'framework' | 'concept' | 'comparison' |
// 'strategy' | 'policy'. Validated 2026-05-02 against IB + Brand data.
// Kept as a separate constant from Category for semantic clarity (flashcards
// MAY in the future diverge from question categorization), but values are aligned.
export const FLASHCARD_TYPE_VALUES = [
    'fact',
    'causal',
    'framework',
    'concept',
    'comparison',
    'strategy',
    'policy',
];
export const FlashcardTypeSchema = z.enum(FLASHCARD_TYPE_VALUES);
//# sourceMappingURL=flashcard-type.js.map